import { render, staticRenderFns } from "./Noticia.vue?vue&type=template&id=3c1123ce&scoped=true"
import script from "./Noticia.vue?vue&type=script&lang=js"
export * from "./Noticia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1123ce",
  null
  
)

export default component.exports